import Api2Talk from "../api2talk";

// Item 09 (16/10/2026) — copiloto de IA do editor de fluxo (JOINT). Backend: api/chatbot-flow-copilot (2Talk).
// COPILOT_USE_MOCK = true → front-first: respostas simuladas pra validar a UX antes de ligar no backend.
export const COPILOT_USE_MOCK = false;

const PATH = '/chatbot-flow-copilot';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// ---------------------------------------------------------------- normalizers (API devolve tudo em minúsculo)

export const normalizeCopilotLlm = (llm) => ({
  id: llm?.id,
  name: llm?.name ?? '',
  llmTypeId: llm?.llmtypeid ?? llm?.llmTypeId,
  model: llm?.model ?? '',
});

export const normalizeCopilotAvailability = (data) => ({
  enabled: data?.enabled ?? false,
  llms: (data?.llms ?? []).map(normalizeCopilotLlm),
});

export const normalizeCopilotIssue = (issue) => ({
  severity: issue?.severity ?? 'error',
  nodeKey: issue?.node_key ?? issue?.nodekey ?? issue?.nodeKey ?? null,
  code: issue?.code ?? '',
  message: issue?.message ?? '',
});

export const normalizeCopilotAskResult = (data) => ({
  status: data?.status ?? '',
  assistantMessage: data?.assistantmessage ?? data?.assistantMessage ?? '',
  jsonFlow: data?.jsonflow ?? data?.jsonFlow ?? null,
  historyId: data?.historyid ?? data?.historyId ?? null,
  conversationId: data?.conversationid ?? data?.conversationId ?? null,
  issues: (data?.issues ?? []).map(normalizeCopilotIssue),
  replacesFlow: data?.replacesflow ?? data?.replacesFlow ?? false,
});

export const normalizeCopilotHistoryItem = (item) => ({
  id: item?.id,
  conversationId: item?.conversationid ?? item?.conversationId,
  mode: item?.mode ?? '',
  status: item?.status ?? '',
  llmId: item?.llmid ?? item?.llmId ?? null,
  llmModel: item?.llmmodel ?? item?.llmModel ?? '',
  attempt: item?.attempt ?? 1,
  parentHistoryId: item?.parenthistoryid ?? item?.parentHistoryId ?? null,
  userPrompt: item?.userprompt ?? item?.userPrompt ?? '',
  assistantMessage: item?.assistantmessage ?? item?.assistantMessage ?? '',
  errorMessage: item?.errormessage ?? item?.errorMessage ?? '',
  canRestore: item?.canrestore ?? item?.canRestore ?? false,
  createdAt: item?.createdat ?? item?.createdAt ?? null,
});

export const normalizeCopilotPromptTemplate = (t) => ({
  id: t?.id,
  code: t?.code ?? null,
  title: t?.title ?? '',
  description: t?.description ?? '',
  boxesSummary: t?.boxessummary ?? t?.boxesSummary ?? '',
  prompt: t?.prompt ?? '',
  mode: t?.mode ?? 'create',
  isSystem: t?.issystem ?? t?.isSystem ?? false,
});

// ---------------------------------------------------------------- mock

let mockHistory = [];
let mockId = 1000;

const mockAvailability = () => ({
  success: true,
  data: {
    enabled: true,
    llms: [
      { id: 1, name: 'GPT Atendimento', llmtypeid: 1, model: 'gpt-4.1-mini' },
      { id: 2, name: 'Gemini Suporte', llmtypeid: 2, model: 'gemini-2.5-flash' },
    ],
  },
});

const mockTemplates = () => ({
  success: true,
  data: [
    { id: 1, code: 'welcome_menu', title: 'Boas-vindas com menu', mode: 'create', issystem: true,
      description: 'O básico de todo atendimento: cumprimenta o cliente e oferece um menu para tirar dúvidas, falar com um atendente ou encerrar.',
      boxessummary: 'Mensagem com opções, Orientação, Falar com atendente, Fim',
      prompt: 'Crie do zero um fluxo de boas-vindas com menu: Tirar dúvidas, Falar com atendente e Encerrar.' },
    { id: 2, code: 'business_hours', title: 'Atendimento com horário comercial', mode: 'create', issystem: true,
      description: 'Verifica o expediente antes de tudo: fora do horário avisa e oferece deixar um recado; dentro do horário segue para o menu.',
      boxessummary: 'Horário de atendimento, Mensagem com opções, Pergunta, Nota, Falar com atendente, Fim',
      prompt: 'Crie do zero um fluxo que começa verificando o horário de atendimento.' },
    { id: 3, code: 'ticket_attachments', title: 'Consulta de chamado com anexos', mode: 'create', issystem: true,
      description: 'Identifica o cliente, lista os chamados dele, mostra o detalhe e envia os anexos.',
      boxessummary: 'Ações nativas, Lista interativa, Condição, Mensagem com opções, Falar com atendente',
      prompt: 'Crie do zero um fluxo de autoatendimento de chamados com anexos.' },
    { id: 1001, code: null, title: 'Adicionar pesquisa de satisfação no final', mode: 'edit', issystem: false,
      description: 'Template do cliente (exemplo): altera o fluxo atual em vez de criar um novo.',
      boxessummary: 'Avaliação', prompt: 'Antes de cada encerramento, adicione a pesquisa de satisfação.' },
  ],
});

const mockAsk = async (flowId, input) => {
  await delay(2500);
  const conversationId = input.conversationId ?? `mock-${Date.now()}`;
  const fail = /erro|falha/i.test(input.prompt ?? '');
  const id = ++mockId;
  const result = fail
    ? {
        status: 'validation_failed',
        assistantmessage: 'Tentei adicionar a busca do pedido, mas a variável "pedido" não existe no cadastro.',
        jsonflow: null,
        historyid: id,
        conversationid: conversationId,
        issues: [
          { severity: 'error', node_key: 'buscar_pedido', code: 'unknown_variable', message: "Variável 'pedido' (result_variable) não está cadastrada — use uma variável existente." },
          { severity: 'warning', node_key: 'menu', code: 'output_not_linked', message: "Saída 'Encerrar' de 'Menu principal' não está ligada (o bot para ali)." },
        ],
      }
    : {
        status: 'success',
        assistantmessage: 'Pronto! (simulação) Adicionei a opção "Falar com atendente" no menu principal e liguei ela à transferência.',
        jsonflow: input.baseJson,
        historyid: id,
        conversationid: conversationId,
        issues: [],
      };
  mockHistory = [{
    id, conversationid: conversationId, mode: 'edit', status: result.status, llmid: input.llmId, llmmodel: 'mock',
    attempt: 1, userprompt: input.prompt, assistantmessage: result.assistantmessage,
    errormessage: fail ? 'validation_failed' : '', canrestore: !fail, createdat: new Date().toISOString(),
  }, ...mockHistory];
  return { success: !fail, errors: fail ? [result.assistantmessage] : [], data: result };
};

const mockRestore = async (flowId, historyId, target, currentJson) => {
  await delay(800);
  return {
    success: true,
    data: {
      status: 'restored',
      assistantmessage: target === 'after' ? 'Versão reaplicada.' : 'Alteração desfeita.',
      jsonflow: currentJson,
      historyid: ++mockId,
      conversationid: null,
      issues: [],
    },
  };
};

// ---------------------------------------------------------------- API

const getAvailability = async () => {
  if (COPILOT_USE_MOCK) return mockAvailability();
  try {
    const response = await Api2Talk.get(`${PATH}/availability`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getTemplates = async () => {
  if (COPILOT_USE_MOCK) return mockTemplates();
  try {
    const response = await Api2Talk.get(`${PATH}/templates`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/** input: { prompt, llmId, conversationId, baseJson, replace } */
const ask = async (flowId, input) => {
  if (COPILOT_USE_MOCK) return mockAsk(flowId, input);
  try {
    const response = await Api2Talk.post(`${PATH}/${flowId}/ask`, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getHistory = async (flowId, limit = 50) => {
  if (COPILOT_USE_MOCK) return { success: true, data: mockHistory };
  try {
    const response = await Api2Talk.get(`${PATH}/${flowId}/history?limit=${limit}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

/** target: 'before' (desfazer) | 'after' (reaplicar). currentJson só é usado pelo mock. */
const restore = async (flowId, historyId, target, currentJson) => {
  if (COPILOT_USE_MOCK) return mockRestore(flowId, historyId, target, currentJson);
  try {
    const response = await Api2Talk.post(`${PATH}/${flowId}/history/${historyId}/restore`, { target });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export {
  getAvailability,
  getTemplates,
  ask,
  getHistory,
  restore,
};
